import { Link, useSearchParams } from "react-router-dom";
import { PropertyForm } from "../properties/PropertyForm.js";
import { useCreateProperty } from "../properties/api.js";

/**
 * Only allow `?next=` redirects that point back into our own app shell.
 * Anything else (off-site URLs, protocol-relative paths, etc.) falls back
 * to the default Properties list to avoid open-redirect issues.
 */
function safeNext(raw: string | null): string | null {
  if (!raw) return null;
  if (!raw.startsWith("/app/")) return null;
  return raw;
}

export function NewProperty() {
  const createMutation = useCreateProperty();
  const [searchParams] = useSearchParams();
  const next = safeNext(searchParams.get("next"));

  const backTo = next ?? "/app/properties";
  const backLabel = next === "/app/rfqs/new" ? "New request" : "Properties";
  const redirectTo = next ?? "/app/properties";

  return (
    <div>
      <header className="border-b border-slate-200 bg-white px-4 py-3">
        <Link to={backTo} className="text-sm text-teal-700">
          ‹ {backLabel}
        </Link>
        <h1 className="mt-1 text-xl font-semibold">New property</h1>
      </header>
      <PropertyForm
        submitLabel="Create"
        onSubmit={(input) => createMutation.mutateAsync(input)}
        redirectTo={redirectTo}
      />
    </div>
  );
}
